import { ColorV2 } from "config/colors";
import styled from "styled-components";

export const WorkerRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: ${ColorV2.White};
  border-radius: 14px;
  padding: 12px 14px;
`;

export const WorkerLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 240px;
`;

export const WorkerRight = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
`;

export const CopyButtonWrap = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
`;

export const CustomerDropdownWrap = styled.div`
  width: 170px;
`;

export const TeamDropdownWrap = styled.div`
  width: 170px;
`;

export const TrashWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-left: 0;
`;
